import { render, staticRenderFns } from "./Float-Motion.vue?vue&type=template&id=4fed96b7"
import script from "./Float-Motion.vue?vue&type=script&lang=js"
export * from "./Float-Motion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports